import { requiredRule } from '../../utils';
import { FieldType, RecipeField } from './common';

export function dynamicConnectionFieldsMapper(json): RecipeField[] {
    const fields: RecipeField[] = [];
    const typeName: string = json.edc_connector_type;

    const dataSystemFields: RecipeField[] = [
        {
            name: `${typeName}.platform_instance`,
            label: 'Select Platform Instance',
            tooltip: '',
            type: FieldType.SEARCH_SELECT,
            fieldPath: 'source.config.platform_instance',
            placeholder: 'Select Platform Instance',
            rules: [{ required: true, message: 'Platform Instance is required' }],
            disabled: true,
            required: true,
            options: [],
        },
    ];

    const processField = (field) => {
        const optionsEnabledFields = [FieldType.SELECT, FieldType.SEARCH_SELECT];
        return {
            name: field.name,
            label: field.label,
            tooltip: field.tooltip,
            type: field.type,
            fieldPath: field.fieldPath,
            placeholder: field.placeholder,
            rules: field.required ? requiredRule(field.label) : null,
            required: field.required,
            options: optionsEnabledFields.includes(field.type) ? field.options : undefined,
            setOptions: optionsEnabledFields.includes(field.type)
                ? function (this: RecipeField, data) {
                      if (data) {
                          this.options = data.map((dataField) => ({
                              value: String(dataField.id),
                              label: dataField.name,
                              applianceId: dataField.applianceId,
                          }));
                      } else {
                          this.options = [];
                      }
                  }
                : undefined,
        };
    };

    dataSystemFields.forEach((field) => {
        fields.push(processField(field));
    });

    if (json.additional_fields) {
        json.additional_fields.forEach((field) => {
            fields.push(processField(field));
        });
    }

    return fields;
}

export function updatePlatformInstanceFields(
    updatedFields: RecipeField[],
    type: string,
    results: any[],
    form: any,
): RecipeField[] {
    return updatedFields.map((field) => {
        if (field.name === `${type}.platform_instance`) {
            form.setFieldValue(`${type}.platform_instance`, null);
            field.setOptions(results);
            return {
                ...field,
                disabled: results.length === 0,
            };
        }
        return field;
    });
}
